/** Two short lines stacked, as the map's date and time cells draw them. */
export const TwoLines = ({ first, second }: { first: string; second: string }) => (
  <div className="flex flex-col text-xs leading-4 text-text-body">
    <span className="whitespace-nowrap">{first}</span>
    <span className="whitespace-nowrap">{second}</span>
  </div>
);
